// import React from "react";
// import { Link } from "react-router-dom";

// function Categoriespage({ item }) {
//     return (
//         <>
//             {/* <div className="shutter-card">
//       <Link
//         to={`/categories/${item?.slug || item?.slugPath}`}
//         className="image img-style d-block"
//       >
//         <div className="img-layer">

//           {item?.image && (
//             <img src={item?.image} alt="categories" className="lazyload" />
//           )}
//         </div>
//         <div className="shutter-panel panel-left"></div>
//         <div className="shutter-panel panel-right"></div>
//         <div className="content-layer">
//           <div className="text-box">         
//             <h3>{item.name}</h3>       
//             <div className="btn-wrapper">
//               <Link to="/shop" className="shutter-btn">
//                 View 
//               </Link>
//             </div>
//           </div>
//         </div>
//         <div className="border-trace"></div>
//       </Link>
//     </div> */}


//             <div className="simple-card">
//                 <Link
//                     to={`/categories/${item?.slug || item?.slugPath}`}
//                     className="image img-style d-block"
//                 >
//                     <div className="card-top-catg">
//                         {/* <img src={t.img} alt={t.title} /> */}
//                         {item?.image && (
//                             <img src={item?.image} alt="categories" className="lazyload" />
//                         )}
//                     </div>
//                     <div className="card-body-v3 text-center">
//                         <h4>{item?.name}</h4>
//                         <p>{item?.description}</p>

//                         <a
//                         //   href="https://wa.me/9017532000?text=Hi%20I%20need%20help%20for%20${encodeURIComponent(item?.name)}`}"
//                         href={`https://wa.me/9017532000?text=Hi%20I%20need%20help%20for%20${encodeURIComponent(item?.name)}`}
//                           target="_blank"
//                           rel="noopener noreferrer"
//                           className="ax-whatsapp-btn"
//                         >

//                           <span>Connect to WhatsApp</span>
//                         </a>
//                     </div>
//                 </Link>
//             </div>
//         </>
//     );
// }

// export default Categoriespage;











import React from "react";
import { Link } from "react-router-dom";


function Categoriespage({ item }) {
  return (
    <>
      <div className="">
        <Link
          to={`/categories/${item?.slug || item?.slugPath}`}
          className="image img-style d-block"
        >
          <div className="health-card">

            {/* Image */}
            <div className="health-card-img">
              {/* <img src={item?.image} alt={item?.name} /> */}
              {item?.image && (
                <img src={item?.image} alt="categories" className="lazyload" />
              )}
            </div>

            {/* Content */}
            <div className="health-card-body">
              <h4>{item?.name}</h4>

              <p>
                {item?.shortDescription?.slice(0, 60)}...
              </p>

              <a
                href={`https://wa.me/9017532000?text=Hi I need help for ${encodeURIComponent(item?.name)}`}
                target="_blank"
                rel="noopener noreferrer"
                className="appointment-btn"
              >
                Connect To Whatsapp
              </a>
            </div>
          </div>
        </Link>
      </div>
    </>
  );
}

export default Categoriespage;